/*
 * Countries.js - A map of country names written in English to ISO
 * 3166 region codes
 *
 * Copyright © 2022 JEDLSoft
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const countries = {
    "afghanistan": "AF",
    "aland islands": "AX",
    "åland islands": "AX",
    "albania": "AL",
    "algeria": "DZ",
    "american samoa": "AS",
    "andorra": "AD",
    "angola": "AO",
    "anguilla": "AI",
    "antigua and barbuda": "AG",
    "antigua & barbuda": "AG",
    "antigua": "AG",
    "barbuda": "AG",
    "argentina": "AR",
    "armenia": "AM",
    "aruba": "AW",
    "australia": "AU",
    "austria": "AT",
    "azerbaijan": "AZ",
    "bahamas": "BS",
    "the bahamas": "BS",
    "bahrain": "BH",
    "bangladesh": "BD",
    "barbados": "BB",
    "belarus": "BY",
    "belgium": "BE",
    "belize": "BZ",
    "benin": "BJ",
    "bermuda": "BM",
    "bhutan": "BT",
    "bolivia, plurinational state of": "BO",
    "plurinational state of bolivia": "BO",
    "bolivia": "BO",
    "bosnia and herzegovina": "BA",
    "bosnia & herzegovina": "BA",
    "bosnia": "BA",
    "herzegovina": "BA",
    "botswana": "BW",
    "bouvet island": "BV",
    "brazil": "BR",
    "british indian ocean territory": "IO",
    "brunei darussalam": "BN",
    "brunei": "BN",
    "bulgaria": "BG",
    "burkina faso": "BF",
    "burundi": "BI",
    "cambodia": "KH",
    "cameroon": "CM",
    "canada": "CA",
    "cape verde": "CV",
    "cape verde islands": "CV",
    "cayman islands": "KY",
    "caymans": "KY",
    "central african republic": "CF",
    "c.a.r.": "CF",
    "car": "CF",
    "chad": "TD",
    "chile": "CL",
    "people's republic of china": "CN",
    "republic of china": "TW",
    "p. r. of china": "CN",
    "p. r. china": "CN",
    "p.r. of china": "CN",
    "pr china": "CN",
    "R.O.C.": "TW",
    "ROC": "TW",
    "prc": "CN",
    "china": "CN",
    "christmas island": "CX",
    "cocos (keeling) islands": "CC",
    "cocos islands": "CC",
    "cocos and keeling islands": "CC",
    "cocos & keeling islands": "CC",
    "colombia": "CO",
    "comoros": "KM",
    "congo": "CG",
    "congo-brazzaville": "CG",
    "west congo": "CG",
    "congo republic": "CG",
    "congo, the democratic republic of": "CD",
    "congo, democratic republic of": "CD",
    "congo, the democratic republic of the": "CD",
    "congo, democratic republic of the": "CD",
    "the democratic republic of congo": "CD",
    "democratic republic of congo": "CD",
    "the democratic republic of the congo": "CD",
    "democratic republic of the congo": "CD",
    "drc": "CD",
    "cook islands": "CK",
    "costa rica": "CR",
    "cote d'ivoire": "CI",
    "côte d'ivoire": "CI",
    "ivory coast": "CI",
    "croatia": "HR",
    "cuba": "CU",
    "cyprus": "CY",
    "the czech republic": "CZ",
    "czech republic": "CZ",
    "denmark": "DK",
    "djibouti": "DJ",
    "dominica": "DM",
    "dominican republic": "DO",
    "d.r.": "DO",
    "dr": "DO",
    "ecuador": "EC",
    "egypt": "EG",
    "el salvador": "SV",
    "equatorial guinea": "GQ",
    "eritrea": "ER",
    "estonia": "EE",
    "ethiopia": "ET",
    "falkland islands": "FK",
    "falklands": "FK",
    "malvinas": "FK",
    "faroe islands": "FO",
    "faroes": "FO",
    "fiji": "FJ",
    "finland": "FI",
    "france": "FR",
    "french guiana": "GF",
    "french polynesia": "PF",
    "polynesia": "PF",
    "french southern territories": "TF",
    "gabon": "GA",
    "gabonese republic": "GA",
    "gambia": "GM",
    "republic of the gambia": "GM",
    "georgia": "GE",
    "germany": "DE",
    "ghana": "GH",
    "gibraltar": "GI",
    "greece": "GR",
    "greenland": "GL",
    "grenada": "GD",
    "guadeloupe": "GP",
    "guam": "GU",
    "guatemala": "GT",
    "guernsey": "GG",
    "guinea": "GN",
    "guinea-bissau": "GW",
    "republic of guinea-bissau": "GW",
    "guyana": "GY",
    "cooperative republic of guyana": "GY",
    "haiti": "HT",
    "heard island and mcdonald islands": "HM",
    "heard island & mcdonald islands": "HM",
    "heard and mcdonald islands": "HM",
    "heard island": "HM",
    "mcdonald islands": "HM",
    "holy see": "VA",
    "vatican city state": "VA",
    "vatican city": "VA",
    "vatican": "VA",
    "honduras": "HN",
    "hong kong": "HK",
    "hungary": "HU",
    "iceland": "IS",
    "india": "IN",
    "indonesia": "ID",
    "iran, islamic republic of": "IR",
    "islamic republic of iran": "IR",
    "iran": "IR",
    "iraq": "IQ",
    "republic of ireland": "IE",
    "ireland": "IE",
    "éire": "IE",
    "isle of man": "IM",
    "israel": "IL",
    "italy": "IT",
    "jamaica": "JM",
    "japan": "JP",
    "jersey": "JE",
    "jordan": "JO",
    "kazakhstan": "KZ",
    "kenya": "KE",
    "republic of kenya": "KE",
    "kiribati": "KI",
    "korea, democratic people's republic of": "KP",
    "kosovo": "XK",
    "democratic people's republic of korea": "KP",
    "dprk": "KP",
    "north korea": "KP",
    "korea, republic of": "KR",
    "republic of korea": "KR",
    "south korea": "KR",
    "korea": "KR",
    "kuwait": "KW",
    "kyrgyzstan": "KG",
    "lao people's democratic republic": "LA",
    "laos": "LA",
    "latvia": "LV",
    "lebanon": "LB",
    "lesotho": "LS",
    "liberia": "LR",
    "libyan arab jamahiriya": "LY",
    "libya": "LY",
    "liechtenstein": "LI",
    "lithuania": "LT",
    "luxembourg": "LU",
    "macao": "MO",
    "macedonia, the former yugoslav republic of": "MK",
    "macedonia, former yugoslav republic of": "MK",
    "the former yugoslav republic of macedonia": "MK",
    "former yugoslav republic of macedonia": "MK",
    "f.y.r.o.m.": "MK",
    "fyrom": "MK",
    "macedonia": "MK",
    "madagascar": "MG",
    "malawi": "MW",
    "malaysia": "MY",
    "maldives": "MV",
    "mali": "ML",
    "republic of mali": "ML",
    "malta": "MT",
    "marshall islands": "MH",
    "marshalls": "MH",
    "martinique": "MQ",
    "mauritania": "MR",
    "mauritius": "MU",
    "mayotte": "YT",
    "mexico": "MX",
    "micronesia, federated states of": "FM",
    "federated states of micronesia": "FM",
    "micronesia": "FM",
    "moldova, republic of": "MD",
    "republic of moldova": "MD",
    "moldova": "MD",
    "monaco": "MC",
    "mongolia": "MN",
    "montenegro": "ME",
    "montserrat": "MS",
    "morocco": "MA",
    "mozambique": "MZ",
    "myanmar": "MM",
    "namibia": "NA",
    "nauru": "NR",
    "nepal": "NP",
    "holland": "NL",
    "netherlands antilles": "AN",
    "the netherlands": "NL",
    "netherlands": "NL",
    "new caledonia": "NC",
    "new zealand": "NZ",
    "nicaragua": "NI",
    "niger": "NE",
    "nigeria": "NG",
    "norfolk island": "NF",
    "northern mariana islands": "MP",
    "marianas": "MP",
    "norway": "NO",
    "oman": "OM",
    "pakistan": "PK",
    "palau": "PW",
    "palestinian territory, occupied": "PS",
    "occupied palestinian territory": "PS",
    "palestinian territory": "PS",
    "palestinian authority": "PS",
    "palestine": "PS",
    "panama": "PA",
    "papua new guinea": "PG",
    "png": "PG",
    "paraguay": "PY",
    "peru": "PE",
    "the philippines": "PH",
    "philippines": "PH",
    "pitcairn": "PN",
    "poland": "PL",
    "portugal": "PT",
    "puerto rico": "PR",
    "qatar": "QA",
    "reunion": "RE",
    "réunion": "RE",
    "romania": "RO",
    "russian federation": "RU",
    "russia": "RU",
    "rwanda": "RW",
    "saint barthélemy": "BL",
    "saint barthelemy": "BL",
    "saint barts": "BL",
    "st. barthélemy": "BL",
    "st. barthelemy": "BL",
    "st. barts": "BL",
    "st barthélemy": "BL",
    "st barthelemy": "BL",
    "st barts": "BL",
    "saint helena, ascension and tristan da cunha": "SH",
    "saint helena, ascension & tristan da cunha": "SH",
    "saint helena": "SH",
    "st. helena, ascension and tristan da cunha": "SH",
    "st. helena, ascension & tristan da cunha": "SH",
    "st. helena": "SH",
    "st helena, ascension and tristan da cunha": "SH",
    "st helena, ascension & tristan da cunha": "SH",
    "st helena": "SH",
    "ascension": "SH",
    "tristan da cunha": "SH",
    "saint kitts and nevis": "KN",
    "saint kitts & nevis": "KN",
    "saint kitts": "KN",
    "st. kitts and nevis": "KN",
    "st. kitts & nevis": "KN",
    "st. kitts": "KN",
    "st kitts and nevis": "KN",
    "st kitts & nevis": "KN",
    "st kitts": "KN",
    "nevis": "KN",
    "saint lucia": "LC",
    "st. lucia": "LC",
    "st lucia": "LC",
    "saint martin": "MF",
    "st. martin": "MF",
    "st martin": "MF",
    "saint pierre and miquelon": "PM",
    "saint pierre & miquelon": "PM",
    "saint pierre": "PM",
    "st. pierre and miquelon": "PM",
    "st. pierre & miquelon": "PM",
    "st. pierre": "PM",
    "st pierre and miquelon": "PM",
    "st pierre & miquelon": "PM",
    "st pierre": "PM",
    "miquelon": "PM",
    "saint vincent and the grenadines": "VC",
    "saint vincent & the grenadines": "VC",
    "saint vincent": "VC",
    "st. vincent and the grenadines": "VC",
    "st. vincent & the grenadines": "VC",
    "st. vincent": "VC",
    "st vincent and the grenadines": "VC",
    "st vincent & the grenadines": "VC",
    "st vincent": "VC",
    "the grenadines": "VC",
    "grenadines": "VC",
    "samoa": "WS",
    "san marino": "SM",
    "sao tome and principe": "ST",
    "sao tome & principe": "ST",
    "sao tome": "ST",
    "principe": "ST",
    "saudi arabia": "SA",
    "arabia": "SA",
    "senegal": "SN",
    "sénégal": "SN",
    "serbia": "RS",
    "seychelles": "SC",
    "sierra leone": "SL",
    "the republic of singapore": "SG",
    "republic of singapore": "SG",
    "singapore": "SG",
    "slovakia": "SK",
    "slovenia": "SI",
    "solomon islands": "SB",
    "solomons": "SB",
    "somalia": "SO",
    "south africa": "ZA",
    "south georgia and the south sandwich islands": "GS",
    "south georgia & the south sandwich islands": "GS",
    "south georgia": "GS",
    "the south sandwich islands": "GS",
    "south sandwich islands": "GS",
    "spain": "ES",
    "sri lanka": "LK",
    "the sudan": "SD",
    "sudan": "SD",
    "suriname": "SR",
    "svalbard and jan mayen": "SJ",
    "svalbard & jan mayen": "SJ",
    "svalbard": "SJ",
    "jan mayen": "SJ",
    "swaziland": "SZ",
    "sweden": "SE",
    "switzerland": "CH",
    "syrian arab republic": "SY",
    "syria": "SY",
    "taiwan": "TW",
    "tajikistan": "TJ",
    "tanzania, united republic of": "TZ",
    "united republic of tanzania": "TZ",
    "tanzania": "TZ",
    "thailand": "TH",
    "timor-leste": "TL",
    "east timor": "TL",
    "togo": "TG",
    "tokelau": "TK",
    "tonga": "TO",
    "trinidad and tobago": "TT",
    "trinidad & tobago": "TT",
    "trinidad": "TT",
    "tobago": "TT",
    "tunisia": "TN",
    "turkey": "TR",
    "turkmenistan": "TM",
    "turks and caicos islands": "TC",
    "turks & caicos islands": "TC",
    "turks islands": "TC",
    "turk islands": "TC",
    "caicos islands": "TC",
    "caico islands": "TC",
    "tuvalu": "TV",
    "uganda": "UG",
    "ukraine": "UA",
    "united arab emirates": "AE",
    "u.a.e.": "AE",
    "uae": "AE",
    "dubai": "AE",
    "united kingdom": "GB",
    "u.k.": "GB",
    "uk": "GB",
    "great britain": "GB",
    "g.b.": "GB",
    "gb": "GB",
    "england": "GB",
    "scotland": "GB",
    "wales": "GB",
    "united states": "US",
    "united states of america": "US",
    "u.s.a.": "US",
    "usa": "US",
    "united states minor outlying islands": "UM",
    "uruguay": "UY",
    "uzbekistan": "UZ",
    "vanuatu": "VU",
    "venezuela, bolivarian republic of": "VE",
    "bolivarian republic of venezuela": "VE",
    "venezuela": "VE",
    "viet nam": "VN",
    "vietnam": "VN",
    "british virgin islands": "VG",
    "virgin islands, british": "VG",
    "bvis": "VG",
    "b.v.i.": "VG",
    "bvi": "VG",
    "virgin islands, us": "VI",
    "the us virgin islands": "VI",
    "us virgin islands": "VI",
    "virgin islands": "VI",
    "usvi": "VI",
    "wallis and futuna": "WF",
    "wallis & futuna": "WF",
    "wallis": "WF",
    "futuna": "WF",
    "western sahara": "EH",
    "yemen": "YE",
    "zambia": "ZM",
    "zimbabwe": "ZW"
};
